var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.125C9.65625 13.125 9.36208 13.0027 9.1175 12.7581C8.87292 12.5135 8.75042 12.2192 8.75 11.875V9.375C8.75 9.03125 8.8725 8.73708 9.1175 8.4925C9.3625 8.24792 9.65667 8.12542 10 8.125H12.5C12.8438 8.125 13.1381 8.2475 13.3831 8.4925C13.6281 8.7375 13.7504 9.03167 13.75 9.375V11.875C13.75 12.2188 13.6277 12.5131 13.3831 12.7581C13.1385 13.0031 12.8442 13.1254 12.5 13.125H10ZM1.25 11.25V10H6.875V11.25H1.25ZM10 6.875C9.65625 6.875 9.36208 6.75271 9.1175 6.50813C8.87292 6.26354 8.75042 5.96917 8.75 5.625V3.125C8.75 2.78125 8.8725 2.48708 9.1175 2.2425C9.3625 1.99792 9.65667 1.87542 10 1.875H12.5C12.8438 1.875 13.1381 1.9975 13.3831 2.2425C13.6281 2.4875 13.7504 2.78167 13.75 3.125V5.625C13.75 5.96875 13.6277 6.26312 13.3831 6.50813C13.1385 6.75313 12.8442 6.87542 12.5 6.875H10ZM1.25 5V3.75H6.875V5H1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.ce4b91e2a06b0c68dfeed138b6861c08.svg";
export { ForwardRef as ReactComponent };